import type { ApiScheduledGame } from "../../../api";

export function canUserPlayGame(
  game: ApiScheduledGame,
  playedGames: { gameId: string }[],
): boolean {
  switch (game.status) {
    case "upcoming":
      return false;
    case "about_to_start":
      return true;
    case "in_progress":
      return true;
    case "finished":
      return isGameParticipated(game.id, playedGames);
  }
}

export function canUserViewGame(
  game: ApiScheduledGame,
  playedGames: { gameId: string }[],
): boolean {
  switch (game.status) {
    case "upcoming":
      return true;
    case "about_to_start":
      return true;
    case "in_progress":
      return true;
    case "finished":
      return isGameParticipated(game.id, playedGames);
  }
}

function isGameParticipated(
  gameId: string,
  playedGames: { gameId: string }[],
): boolean {
  return playedGames.some((g) => g.gameId === gameId);
}
